import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function requireTipPakovanjaIfNeeded(
  akciznaField: string,
  tipPakovanjaIdField: string,
  tipPakovanjaTextField: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fg = control as FormGroup;
    if (!fg?.controls) return null;

    const akc = (fg.get(akciznaField)?.value ?? '').toString().trim().toUpperCase();
    const isAkcizna = akc !== '' && akc !== 'NIJE AKCIZNA ROBA';

    const idCtrl = fg.get(tipPakovanjaIdField);
    const textCtrl = fg.get(tipPakovanjaTextField);

    // očisti stare greške
    const clear = (ctrl: any) => {
      if (!ctrl?.errors?.requiredTipPakovanja) return;
      const { requiredTipPakovanja, ...rest } = ctrl.errors;
      ctrl.setErrors(Object.keys(rest).length ? rest : null);
    };
    clear(idCtrl);
    clear(textCtrl);

    if (!isAkcizna) return null;

    if (akc === 'NIKOTIN') {
      const t = (textCtrl?.value ?? '').toString().trim();
      if (!t) {
        textCtrl?.setErrors({ ...(textCtrl.errors || {}), requiredTipPakovanja: true });
        return { requiredTipPakovanja: true };
      }
      return null;
    }

    const v = idCtrl?.value;
    if (v == null || v === '') {
      idCtrl?.setErrors({ ...(idCtrl.errors || {}), requiredTipPakovanja: true });
      return { requiredTipPakovanja: true };
    }

    return null;
  };
}
